
  <br>
  <div style="padding:20px;">
    <form [formGroup]="form">
      <!-- Inte Kanslist eller sysadmin -->
      <div *ngIf="currentinstitution" class="form-group">
        Lägg till utmärkelse för
        <strong *ngIf="!selectedinstitution">{{currentinstitution?.shortName}} - {{currentinstitution?.name}}</strong>
        <strong *ngIf="selectedinstitution">{{selectedinstitutionname}}</strong>
      </div>
      <div class="row col-lg-10 col-md-10 col-sm-11 col-xs-11 d-flex justify-content-between p-1" style="border:1px solid #F0F0F0;">
        <div *ngIf="!currentinstitution && useraccess.roleId!==12 && useraccess.roleId!==13" class="form-group">
          <label>Institution..</label>
          <select class="form-control form-control-sm" id="institutionId" formControlName="institutionId" (change)="getSigns2()" required>
            <option *ngFor="let m of memberships" [value]="m.institution.id">{{m.institution.shortName}}
              {{m.institution.name}}</option>
          </select>
        </div>
        <div *ngIf="(useraccess.roleId===12 || useraccess.roleId===13)" class="d-flex align-items-end">
          <span class="ui-float-label">
             <label *ngIf="!selectedinstitution" class="d-flex mt-n2">Lägg till utmärkelse i</label>
            <p-dropdown *ngIf="!selectedinstitution" [options]="institutions" [multiple]="false" [checkbox]="false" [filter]="true" optionLabel="name" [style]="{'width':'250px'}" appendTo="body" (onChange)="institutionSelected($event)">
            </p-dropdown>
           
          </span>
          <div *ngIf="selectedinstitution">
            <label>Lägg till utmärkelse i</label>
            <b style="font-size:14px;">{{selectedinstitutionname}}</b>
            <button class="btn border mb-2" style="margin-left:20px;" title="Byt institution" (click)="selectedinstitution=null;">Byt</button>
          </div>
        </div>



<div class="d-flex justify-content-between align-items-center">





        <div *ngIf="(useraccess.roleId===12 || useraccess.roleId===13) && currentinstitution" class="d-flex align-items-end px-2">
          <span class="ui-float-label">
            <label *ngIf="!searchselectedinstitution" class="d-flex mt-n2">Sök medlem i</label>
            <p-select *ngIf="!searchselectedinstitution" [options]="institutionslist" [multiple]="false" [checkbox]="false" [filter]="true" formControlName="institutionId" [style]="{'width':'250px'}" appendTo="body" (change)="searchInstitutionSelected($event)">
            </p-select>
            
          </span>
          <div *ngIf="searchselectedinstitution">
            <label>Sök medlem i:</label>
            <b style="font-size:14px;">{{searchselectedinstitutionname}}</b>
            <button class="btn border mb-2" style="margin-left:20px;" title="Byt institution" (click)="searchselectedinstitution=null;">Byt</button>
          </div>
        </div>
        <div *ngIf="type==='institution'" class="form-group">
          <label for="memberId">
            Medlemsnr
          </label>
          <input type="text" class="form-control form-control-sm" id="memberId" style="width:90px;" formControlName="memberId">
        </div>
        <div *ngIf="type==='institution'" class="form-group">
          <label for="givenName">
            Förnamn
          </label>
          <input type="text" class="form-control form-control-sm" id="givenName" formControlName="givenName">
        </div>
        <div *ngIf="type==='institution'" class="form-group">
          <label for="familyName">
            Efternamn
          </label>
          <input type="text" class="form-control form-control-sm" id="familyName" formControlName="familyName">
        </div>
        <div *ngIf="type==='institution' && useraccess?.roleId!==1 && useraccess?.roleId!==6" class="form-group">
          <label for="familyName">
            Ta med inaktiva
          </label>
          <mat-checkbox #inputEl (change)="setOnlyActive(inputEl);" formControlName="IncludeNonCurrentInstitutions"></mat-checkbox>
        </div>
        <div *ngIf="type==='institution'" class="form-group">
          <label>&nbsp;</label>
          <button class="btn border" (click)="search()">Sök</button>
        </div>




</div>



        <div *ngIf="type==='member'">{{memberId}}</div>
        <div *ngIf="type==='member'">{{givenName}}</div>
        <div *ngIf="type==='member'">{{familyName}}</div>
        <div *ngIf="type==='member'"></div>
      </div>
    </form>
  </div>
  <div *ngIf="members?.length > 0" class="col-lg-5 col-md-8 col-sm-11 col-xs-11 ms-2 me-2">
    <mat-expansion-panel [expanded]=true style="margin-top:20px;">
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          Sökresultat - Antal: {{members?.length}}
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <table *ngIf="members.length > 0" matSort (matSortChange)="sortData($event)" class="table" matSortDisableClear=true>
        <thead role="rowgroup">
          <tr>
            <th mat-sort-header="id">Id</th>
            <th mat-sort-header="givenName">Förnamn</th>
            <th mat-sort-header="familyName">Efternamn</th>
            <th>Prim.inst.</th>
            <th style="z-index: 10000;">Välj</th>
          </tr>
        </thead>
        <tr class="tr" *ngFor="let m of members;">
          <td style="text-align: left;">
            <a [routerLink]="['/memberform/id/', m.id]">{{m.id}}</a>
          </td>
          <td>{{m.givenName}}</td>
          <td>{{m.familyName}}</td>

          <td><a [routerLink]="['/institutions/id/', m.primaryInstitution.id]" title="{{m.primaryInstitution.name}}">{{m.primaryInstitution.shortName}}</a></td>
          <td style="text-align: center;vertical-align: middle;">
            <mat-checkbox #inputEl (change)="add(m, inputEl);" [checked]="m.checked"></mat-checkbox>
          </td>
        </tr>
      </table>
    </mat-expansion-panel>
  </div>
  <div>
    <mat-expansion-panel *ngIf="showFilteredList && selectedSignsForm.get('items').value.length > 0" [expanded]="showFilteredList" class="accordionmargin ms-2">
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          Lägg till grader/utmärkelser
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <form [formGroup]="selectedSignsForm">
        <div class="table_wrapper">
          <table formArrayName="items" class="table table-bordered" style="width:100%;">
            <thead role="rowgroup">
              <tr>
                <th>Förnamn</th>
                <th>Efternamn</th>
                <th>Grader/utmärkelser</th>
                <th>Datum</th>
                <th></th>
              </tr>
            </thead>
            <tr *ngFor="let item of selectedSignsForm.get('items').controls; let i=index" [formGroupName]="i">
              <td>
                <input formControlName="givenName" class="form-control form-control-sm">
              </td>
              <td>
                <input formControlName="familyName" class="form-control form-control-sm">
              </td>
            
              <td class="d-flex align-items-center">
                <select class="form-control form-control-sm" id="id" formControlName="signId" required>
                  <option></option>
                  <option *ngFor="let s of signs" [value]="s.id">{{s.name}}</option>
                </select>
                <p *ngIf="responseinfo[i]!=='ok'" style="color:red;">{{responseinfo[i]}}</p>
              </td>
              <td>
                <input formControlName="date" class="form-control form-control-sm" mask="0000-00-00" required>
              </td>
              <td>
                <button class="btn border" style="min-width:40px;margin-top:4px;" (click)="removeFromArray(selectedSignsForm.controls.items.controls[i].controls.memberId.value)">
                  <i class="fa fa-times" aria-hidden="true" title="Ångra"></i>
                </button>
              </td>
            </tr>
          </table>
        </div>
        <button class="btn border pull-right" [disabled]="!selectedSignsForm.valid || selectedSignsForm.get('items').value.length === 0" (click)="addSigns()">Lägg till valda grader/utmärkelser</button>
      </form>
    </mat-expansion-panel>
  </div>

<br>
<br>